// Set axios response interceptor for login
import axios from "axios";

axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

const API = axios.create({
  baseURL: process.env.API_URL,
});

const CrewbiesAPI = axios.create({
  baseURL: process.env.CREWBIES_API_URL,
});

const CrewbiesChinaAPI = axios.create({
  baseURL: process.env.CREWBIES_CHINA_API_URL,
});

const CmsAPI = axios.create({
  baseURL: process.env.CMS_API_URL,
});

const CmsAPI2 = axios.create({
  baseURL: process.env.CMS_API_URL2,
});

const CmsFormPostAPI = axios.create({
  baseURL: process.env.CMS_API_URL + "/api",
});

const SignupAPI = axios.create({
  baseURL: process.env.CREWBIES_API_URL + "api/signup-process",
});

const SignupChinaAPI = axios.create({
  baseURL: process.env.CREWBIES_CHINA_API_URL + "api/signup-process",
});

const SigninAPI = axios.create({
  baseURL: process.env.CREWBIES_API_URL + "api/signin-process",
});

const SigninChinaAPI = axios.create({
  baseURL: process.env.CREWBIES_CHINA_API_URL + "api/signin-process",
});

const ForgotPwdAPI = axios.create({
  baseURL: process.env.CREWBIES_API_URL + "api/forgot-password-process",
});

const ForgotPwdChinaAPI = axios.create({
  baseURL: process.env.CREWBIES_CHINA_API_URL + "api/forgot-password-process",
});

const forgotPwdToken = axios.create({
  baseURL: process.env.CREWBIES_API_URL + "api/verify-forgot-password-token",
});

const forgotPwdTokenChina = axios.create({
  baseURL:
    process.env.CREWBIES_CHINA_API_URL + "api/verify-forgot-password-token",
});

const resetPwdtoken = axios.create({
  baseURL: process.env.CREWBIES_API_URL + "api/reset-password-process",
});

const resetPwdtokenChina = axios.create({
  baseURL: process.env.CREWBIES_CHINA_API_URL + "api/reset-password-process",
});

const checkJobStatus = axios.create({
  baseURL: process.env.CREWBIES_API_URL + "api/check-position-status",
});

const checkJobStatusChina = axios.create({
  baseURL: process.env.CREWBIES_CHINA_API_URL + "api/check-position-status",
});

export {
  API,
  CrewbiesAPI,
  CrewbiesChinaAPI,
  CmsAPI,
  CmsAPI2,
  CmsFormPostAPI,
  SignupAPI,
  SignupChinaAPI,
  SigninAPI,
  SigninChinaAPI,
  ForgotPwdAPI,
  ForgotPwdChinaAPI,
  forgotPwdToken,
  forgotPwdTokenChina,
  resetPwdtoken,
  resetPwdtokenChina,
  checkJobStatus,
  checkJobStatusChina,
};
